import { render, staticRenderFns } from "./JournalView.vue?vue&type=template&id=114d4470&scoped=true"
import script from "./JournalView.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JournalView.vue?vue&type=style&index=0&id=114d4470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114d4470",
  null
  
)

export default component.exports